import allTasksReducer from "./allTasks/allTasksReducer";
import assignedSubTasksReducer from "./assignedSubTasks/assignedSubTasksReducer";
import assignedTasksReducer from "./assignedTasks/assignedTasksReducer";
import ownTasksReducer from "./ownTasks/ownTasksReducer";
import priorityReducer from "./settings/priority/priorityReducer";
import statusReducer from "./settings/status/statusReducer";
import sharedSubTasksReducer from "./sharedSubTasks/sharedSubTasksReducer";
import sharedTasksReducer from "./sharedTasks/sharedTasksReducer";
import subTasksReducer from "./subTasks/subTasksReducer";

const taskManagementReducers = {
  allTasksState: allTasksReducer,
  ownTasksState: ownTasksReducer,
  subTasksState: subTasksReducer,
  assignedTasksState: assignedTasksReducer,
  assignedSubTasksState: assignedSubTasksReducer,
  sharedSubTasksState: sharedSubTasksReducer,
  sharedTasksState: sharedTasksReducer,
  settingsPriorityState: priorityReducer,
  settingsStatusState: statusReducer,
};

export default taskManagementReducers;
